// export const ENDPOINT = 'http://localhost:6001/api/v1/'
//export const ENDPOINT = 'http://localhost:6001/api/v1/'
export const BACKEND_URL = 'http://www.biofinance.env.gov.lk/'
export const ENDPOINT = 'http://www.biofinance.env.gov.lk/api/v1/'

export const FILE_VIEW = ''

// session route
export const LOGIN = `${ENDPOINT}auth/login`
export const REGISTER = `${ENDPOINT}auth/register`
export const GETAUTHUSER = `${ENDPOINT}auth/user`

// user services
export const CREATE_USER = `${ENDPOINT}auth/register`
export const EMPLOYEES = `${ENDPOINT}users/`
export const INDIVIDUAL_EMPLOYEES = `${ENDPOINT}users/individual-users`
export const ORGANIZATIONAL_EMPLOYEES = `${ENDPOINT}users/organization-users`
export const USER_APPROVAL = `${EMPLOYEES}user-status/update`
export const MY_PROFILE = `${ENDPOINT}users/myprofile`
export const ORGADMIN_USER_MANAGEMENT = `${EMPLOYEES}orgcontributorsfororgadmin`
export const USER_STATUS_COUNT = `${ENDPOINT}users/getUserStatusCount`

//Organization Services

export const ORGANIZATION = `${ENDPOINT}organizations`
export const ORG_MANAGEMENT = `${ENDPOINT}organizations/admin/get-all`
export const ORG_REVIEW = `${ENDPOINT}organizations/edit`
export const ORG_APPROVAL = `${ENDPOINT}organizations/admin/organization-status/update`
export const ORG_STATUS_COUNT = `${ENDPOINT}organizations/getOrganizationStatusCount`

//Configurations

export const ORG_CONFIG = `${ENDPOINT}organization-config/organization-types`
export const PROJECT_TYPE = `${ENDPOINT}expense-config/project-types`
export const CURRENCY_TYPE = `${ENDPOINT}expense-config/currency-types`
export const EXPENSE_CATEGORY_TYPE = `${ENDPOINT}expense-config/expense-types`
export const TARGET_TYPE = `${ENDPOINT}target-config`
export const TARGET_DETAILS = `${ENDPOINT}targets`

// export const ORGCONFIG_REVIEW = `${ENDPOINT}organization-config/organization-types`
export const EXPENSE_PROJECT_TYPE_REVIEW = `${ENDPOINT}`
export const EXPENSE_CURRENCY_TYPE_REVIEW = `${ENDPOINT}`
export const EXPENSE_CATEGORY_REVIEW = `${ENDPOINT}`


// expense services

export const ADD_EXPENSE = `${ENDPOINT}expense`
export const DASHBOARD_EXPENSE = `${ENDPOINT}expense/dashboard`
export const DASHBOARD_NEAP_TABLE = `${ENDPOINT}expense/dashboard/neap-table`
export const TARGETS = `${ENDPOINT}targets`
export const EXPENSE_UPDATE = `${ENDPOINT}expense/update`
export const EXPENSE_PROGRESS_UPDATE = `${ENDPOINT}expense/updateExpenseProgress`
export const EXPENSE_STATUS_UPDATE = `${ENDPOINT}expense/expense-status/update`
export const EXPENSE_STATUS_COUNT = `${ENDPOINT}expense/getExpenseStatusCount`
export const EXPENSE_PROGRESS = `${ENDPOINT}expense/getSingleExpenseProgress`
export const UPDATE_EXPENSE_PROGRESS = `${ENDPOINT}expense/updateExpenseProgress`
export const EXPENSE_FILTER = `${ENDPOINT}expense/filterExpenseByYear`


